import {
  flattenPushDataPayload,
  resolvePushBody,
} from './pushPayloadCore';
import { resolvePushLinkFromData } from './pushLinkResolvers';

export {
  flattenPushDataPayload,
  flattenSocketNotificationPayload,
  isPlainObject,
  normalizePushText,
  parseObjectSafe,
  readPushTypeKeys,
  resolvePushBody,
  resolvePushTitle,
} from './pushPayloadCore';

export {
  buildCreatorSalesTipActivityLink,
  buildIncomingCallChatLink,
  buildNewContentCreatorProfileLink,
  buildNewMessageChatLink,
  buildPriorityMessagesBannerLink,
  buildTrendingProfileLink,
  resolvePushLinkFromData,
} from './pushLinkResolvers';

export const resolvePushLink = (payload = {}, defaultLink = '') => {
  const data = flattenPushDataPayload(payload);
  const bodyText = resolvePushBody(payload, data);
  return resolvePushLinkFromData(data, { bodyText, defaultLink });
};
